"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Returns an array of passed arguments
 *
 * @module args
 * @func
 * @since 1.16.0
 * @param {...*} vals
 * @return {Array}
 * @example
 *
 *     args(1, 2, [3, 4]); //=> [1, 2, [3, 4]]
 */

var args = function args() {
  for (var _len = arguments.length, vals = Array(_len), _key = 0; _key < _len; _key++) {
    vals[_key] = arguments[_key];
  }

  return vals;
};

exports.default = args;